import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class MixAndMatchScheduleDiscontinueAction {
    constructor(public mixAndMatchScheduleId: number) {
    }
}

/**
 * Action Service to discontinue a mix and match schedule
 */
@Injectable()
export class MixAndMatchScheduleDiscontinueService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "mix-and-match-schedule-discontinue");
    }
}
